import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { authState } from 'rxfire/auth';
import { Observable, of, catchError, map, switchMap, take } from 'rxjs';
import { AuthService } from '@core/service/auth.service';
import { RedirectService } from '@core/service/redirectService.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private router = inject(Router);
  private auth = inject(Auth);
  private authService = inject(AuthService);
  private redirectService = inject(RedirectService);

  private shouldStoreRedirect(url: string): boolean {
    return !url.includes('/authentication/signin') &&
      !url.includes('/authentication/token-login');
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return authState(this.auth).pipe(
      take(1),
      switchMap((user) => {
        if (!user) {
          if (this.shouldStoreRedirect(state.url)) {
            this.redirectService.setRedirectUrl(state.url);
          }
          return of(this.router.parseUrl('/authentication/signin'));
        }

        return this.authService.loadLoggedUserProfile().pipe(
          map(() => true),
          catchError(() => {
            if (this.shouldStoreRedirect(state.url)) {
              this.redirectService.setRedirectUrl(state.url);
            }
            return this.authService.logout().pipe(
              map(() => this.router.parseUrl('/authentication/signin')),
              catchError(() => of(this.router.parseUrl('/authentication/signin')))
            );
          })
        );
      })
    );
  }
}
